import { LanguageType } from "@/translations";

export interface ClientNameParts {
  salutation?: string | null;
  firstName: string;
  lastName: string;
}

export function formatClientDisplayName(client: ClientNameParts, language: LanguageType) {
  const name = `${client.firstName} ${client.lastName.toLocaleUpperCase(language)}`;
  return client.salutation ? `${client.salutation} ${name}` : name;
}
